import RequestUtils from "utils/RequestUtils";

import CreateClientRes from "types/res/payment/CreateClientRes";
import { PlanType } from "types/enum/PlanType";

export default class PaymentApi {
  private constructor() {}

  static async findOrCreateSubscription(
    companyId: number,
    priceId: string,
    isAnnual: boolean
  ): Promise<CreateClientRes> {
    return await RequestUtils.post(
      CreateClientRes,
      `/payment/findOrCreateSubscription/${companyId}/${priceId}`,
      { isAnnual }
    );
  }

  static async findOrCreateSubscriptionOnMail(
    companyId: number,
    priceId: string,
    isAnnual: boolean,
    planType: PlanType
  ) {
    return await RequestUtils.postVoid(
      `/payment/findOrCreateSubscriptionOnMail/${companyId}/${priceId}`,
      { isAnnual, planType }
    );
  }

  static async updatePaymentMethod(companyId: number, paymentMethodId: string) {
    return await RequestUtils.postVoid(
      `/payment/updatePaymentMethod/${companyId}/${paymentMethodId}`,
      {}
    );
  }

  static async createSetupIntent(
    companyId: number
  ): Promise<{ clientSecret: string }> {
    return await RequestUtils.postPlain(
      `/payment/createSetupIntent/${companyId}`,
      {}
    );
  }

  static async getStatus(
    companyId: number
  ): Promise<{
    hasPaymentMethod: boolean;
    trialEnd: string | null;
    willEnd: boolean;
    cancelAt: string | null;
    // ★止まっているか と 払う先★（2026-08-13 に 足した。既存の 4 つは そのまま）
    //   古い server と 繋がる 間は 来ないので すべて 省略可にする。
    suspended?: boolean;
    hostedInvoiceUrl?: string | null;
    amountDueJpy?: number | null;
  }> {
    return await RequestUtils.postPlain(`/payment/status/${companyId}`, {});
  }

  static async cancelSubscription(companyId: number) {
    return await RequestUtils.postVoid(
      `/payment/cancelSubscription/${companyId}`,
      {}
    );
  }

  static async uncancelSubscription(companyId: number) {
    return await RequestUtils.postVoid(
      `/payment/uncancelSubscription/${companyId}`,
      {}
    );
  }
}
